import Swal from 'sweetalert2';

/**
 * Global error handler function.
 * @param {any} error - The caught error object
 * @param {function} navigate - Optional react-router navigate function
 */
export const globalErrorHandler = (error, navigate) => {
  const status = error?.status || error?.response?.status;

  if (status === 403) {
    localStorage.clear();
    sessionStorage.clear();

    if (typeof navigate === 'function') {
      navigate('/login'); // ✅ if passed from component
    } else {
      window.location.href = '/login'; // ✅ fallback
    }

    return;
  }

  const message =
    error?.response?.data?.message || error?.message || 'Failed to save guest data.';

  Swal.fire('Error', message, 'error');
};
